/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CookieConsentCustomerDto } from '../../models/cookie-consent-customer-dto';

export interface ApiIdentityCookieconsentGet$Params {
}

export function apiIdentityCookieconsentGet(http: HttpClient, rootUrl: string, params?: ApiIdentityCookieconsentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CookieConsentCustomerDto>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityCookieconsentGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CookieConsentCustomerDto>;
    })
  );
}

apiIdentityCookieconsentGet.PATH = '/api/identity/cookieconsent';
